import React from "react";
import OrderDetailComponent from "../components/OrderDetail";

const OrderDetail = () => {
  return <OrderDetailComponent />;
};

export default OrderDetail;
